import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Schema from "../schema";

type Props = {
	hotelID: string;
	duplicateItemID: string | undefined;
};

export const useVoucherNewItem = ({ hotelID, duplicateItemID }: Props) => {
	const { data } = useCustomSuspenseQuery(Schema.VoucherNewItem_EditPage_Query, {
		variables: { hotelID, duplicateVoucherID: duplicateItemID },
		fetchPolicy: "network-only",
	});

	return data;
};
